import moment from 'moment';
import globalConfig from '@/core/config/app';

class TimeUtils {
  standardDateTime(dateTimeIso) {
    if (dateTimeIso) {
      return moment(dateTimeIso).format(globalConfig.moment.datetimeFormat);
    }
    return '';
  }

  standardDate(dateTimeIso, skipDay) {
    const doSkipDay = skipDay || false;
    if (dateTimeIso) {
      return moment(dateTimeIso).format(doSkipDay ? globalConfig.moment.dateFormatWithoutDay : globalConfig.moment.dateFormat);
    }
    return '';
  }

  ageInSeconds(dateTimeIso) {
    if (dateTimeIso) {
      const age = moment.duration(moment().diff(moment(dateTimeIso)));
      const ageInSeconds = Math.round(age.asSeconds());
      return Math.floor(ageInSeconds);
    }
    return '';
  }

  ageInMinutes(dateTimeIso) {
    if (dateTimeIso) {
      const age = moment.duration(moment().diff(moment(dateTimeIso)));
      const ageInSeconds = Math.round(age.asSeconds());
      const ageInMinutes = Math.round(age.asMinutes());
      return Math.floor(ageInMinutes);
    }
    return '';
  }

  ageInHours(dateTimeIso) {
    if (dateTimeIso) {
      const age = moment.duration(moment().diff(moment(dateTimeIso)));
      const ageInSeconds = Math.round(age.asSeconds());
      const ageInMinutes = Math.round(age.asMinutes());
      return Math.floor(ageInMinutes / 60);
    }
    return '';
  }

  ageInDays(dateTimeIso) {
    if (dateTimeIso) {
      const age = moment.duration(moment().diff(moment(dateTimeIso)));
      const ageInSeconds = Math.round(age.asSeconds());
      const ageInMinutes = Math.round(age.asMinutes());
      return Math.floor(ageInMinutes / (60 * 24));
    }
    return '';
  }
}

export default new TimeUtils();
